import { getCurrentHubId, getAppConfigSync } from "./getAppConfig";

/**
 * Cache inventory ID and AppConfig data in service worker cache (works without auth)
 * This allows the service worker to use AppConfig for manifest generation without API calls
 * @param {number} inventoryId - The inventory/hub ID
 * @param {Object} appConfig - The AppConfig object to cache
 */
export async function cacheAppConfigForSWPublic(inventoryId, appConfig) {
  try {
    if (!inventoryId || !appConfig) {
      return;
    }

    // Cache inventory ID and AppConfig for service worker
    if ('caches' in window) {
      const cache = await caches.open('smartkart-cache-v2');
      
      // Cache inventory ID and AppConfig
      const cacheData = { inventoryId, appConfig };
      await cache.put(
        '/app-config-cache',
        new Response(JSON.stringify(cacheData), {
          headers: { 'Content-Type': 'application/json' }
        })
      );
    }
  } catch (error) {
    // Silently fail - don't block the app
  }
}

/**
 * Cache inventory ID, auth token, and AppConfig data in service worker cache
 * This allows the service worker to use AppConfig for manifest generation without API calls
 */
export async function cacheAppConfigForSW() {
  try {
    // Get current inventory ID
    const inventoryId = getCurrentHubId();
    if (!inventoryId) {
      return;
    }

    // Get auth token
    const authToken = localStorage.getItem('authtoken');
    if (!authToken) {
      return;
    }

    // Get AppConfig data (should be cached by now)
    const appConfig = getAppConfigSync();

    // Cache inventory ID, auth token, and AppConfig for service worker
    if ('caches' in window) {
      const cache = await caches.open('smartkart-cache-v2');
      
      // Cache inventory ID and AppConfig
      const cacheData = { inventoryId, appConfig };
      await cache.put(
        '/app-config-cache',
        new Response(JSON.stringify(cacheData), {
          headers: { 'Content-Type': 'application/json' }
        })
      );

      // Cache auth token
      await cache.put(
        '/auth-token-cache',
        new Response(JSON.stringify({ token: authToken }), {
          headers: { 'Content-Type': 'application/json' }
        })
      );
    }
  } catch (error) {
    console.error('Error caching AppConfig for service worker:', error);
  }
}

/**
 * Update cached auth token when it changes
 */
export async function updateCachedAuthToken() {
  try {
    const authToken = localStorage.getItem('authtoken');
    if (!authToken || !('caches' in window)) {
      return;
    }

    const cache = await caches.open('smartkart-cache-v2');
    await cache.put(
      '/auth-token-cache',
      new Response(JSON.stringify({ token: authToken }), {
        headers: { 'Content-Type': 'application/json' }
      })
    );
  } catch (error) {
    console.error('Error updating cached auth token:', error);
  }
}



